module.exports = __webpack_public_path__ + "static/media/star.0faad62b.svg";